import Image from 'next/image'
import { useEffect, useState } from 'react'

import { cn } from '@/lib/utils'
import { formatSymbol } from '@/lib/utils/format-util'

interface CryptoIconProps {
  symbol: string
  iconTag?: string
  className?: string
  fallback?: React.ReactNode
}

export const CryptoIcon = ({ symbol, iconTag, className, fallback }: CryptoIconProps) => {
  // Uncurated instruments (no enrichment.icon_tag yet) still often have a
  // same-named file in the icon library (e.g. a bare currency like "USDC"
  // that's never any instrument's base_currency, so resolveIconTag can't
  // find it) — guess the symbol itself before giving up on a real icon.
  const resolvedTag = iconTag || symbol.toUpperCase()
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    setFailed(false)
  }, [resolvedTag])

  if (!resolvedTag || failed) {
    return (
      <div className={cn('relative overflow-hidden rounded-full', className)}>
        {fallback ? (
          fallback
        ) : (
          <div className="bg-foreground/10 text-foreground/60 flex h-full w-full items-center justify-center text-[10px]">
            {symbol.slice(0, 1)}
          </div>
        )}
      </div>
    )
  }

  return (
    <div
      className={cn(
        'relative flex items-center justify-center overflow-hidden rounded-full bg-white',
        className
      )}
    >
      <Image
        width={128}
        height={128}
        alt={formatSymbol(symbol)}
        src={`https://cdn.orderx.com/assets/instrument-icons/${resolvedTag}.svg`}
        // See ExchangeIcon: never a native image drag inside a draggable tab/row.
        draggable={false}
        className="h-full w-auto max-w-none shrink-0 object-contain object-center"
        unoptimized={true}
        onError={() => setFailed(true)}
      />
    </div>
  )
}
